import { ErrorHandler, Injectable } from "@angular/core";
import { AppErrorCode } from "@model";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class AppErrorService implements ErrorHandler {
  private _error$ = new Subject<AppErrorCode>();
  error$ = this._error$.asObservable();

  private _error: AppErrorCode | null = null;

  handleError(error: unknown) {
    console.log("app error", error);
    this.setError(AppErrorCode.UNKNOWN);
  }

  setError(error: AppErrorCode): void {
    this._error$.next(error);
    this._error = error;
  }

  getIsError() {
    return this._error;
  }
}
